package external

import com.jingfangpai.common.data.model.CascadedOption
import ext.isNumber
import kotlinext.js.Object
import kotlinext.js.asJsObject

fun demangledKey(key:String):String{
    val parts = key.split("_")
    return parts.filter { it -> !it.isNullOrBlank() && !it.isNumber()}.joinToString("_")
}

inline fun <reified T: Any> T.toJsObject(): T {
    var jsObject = this.asJsObject();
    Object.keys(jsObject).forEach{ key->
        val restoredKey = demangledKey(key)
        js("jsObject[restoredKey]=jsObject[key];")
    }
    return jsObject as T
}

inline fun <reified T: Any> Array<T>.toJsObject(): Array<T>{
    return this.map { it.toJsObject() }.toTypedArray()
}

inline fun <reified T: Any> Array<CascadedOption<T>>.toJsObject(): Array<CascadedOption<T>>{
    var result = arrayOf<CascadedOption<T>>()
    this.forEach { currentItem ->
        if(!currentItem.children.isNullOrEmpty()){
            currentItem.children = currentItem.children?.map {child->
                if(!child.children.isNullOrEmpty()) child.children = child.children?.map{it->it.toJsObject()}?.toTypedArray()
                child.toJsObject()
            }?.toTypedArray()
        }
        result += currentItem.toJsObject();

    }
    return result
}


